import mixins from '@synergycms_core/less/mixins.js';

export default {
  marginCustomerForm: {},
  defaultStyle: {
    background: '#fff',
    '&$marginCustomerForm':{
      marginBottom: '15px',
    },
    '&$vertical': {
      overflow: 'hidden !important',
      '& $content': {
        padding: '15px',
        '& $starOfferContainer': {
          '& $starOfferDiscount': {
            fontSize: '30px',
            color: '#4F5D70',
            border: 'none',
            padding: '0',
            '@media(max-width:601px)':{
              fontSize: '23px',
            },
          },
          '& div':{
            color: '#4F5D70',
          }
        },
        '& $public':{
          gap: '0',
          flexDirection: 'column',
          '& $flex':{
            flexDirection: 'row',
            "& > button": {
              maxWidth: '177px',
              '@media (max-width: 900px)': {
                width: '144px',
              },
            }
          },
          '& .title':{
            display: 'block',
            margin: '16px auto',
            font: '12px "Roboto", sans-serif',
            color: '#747F8D',
            maxWidth: '325px',

          },
        },
        "& $info": {
          flexDirection: 'column',
          "& $textInfo":{
            width: '100%',
            textAlign: 'center',
            marginTop: '0',
          },
          "& $section":{
            display: 'flex',
            gap: '20px',
          },
          "& $textCenter": {
            marginTop: '20px'
          },
          "& $flex" : {
            marginTop: '20px',
            '@media (min-width: 601px)': {
              flexDirection: 'column',
              padding: '0 10px',
            },
            '@media (min-width: 801px)': {
              flexDirection: 'column',
              padding: '0 10px',
            }
          },
        }
      },
      '& .text':{
        display: 'none',
      },
      '& $starLogo': {
        display: 'none'
      },
    }
  },
  customerFormLogo:{},
  public: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    "& .title":{
      display: 'none',
    },
    "& .text": {
      display: 'flex',
      padding: '10px 0',
      '& svg': {
        width: '22px',
        height: '21px',
        '@media (min-width: 601px)': {
          width: '30px',
          height: '29px',
        }
      },
      "& span": {
        maxWidth: '110px',
        display: 'block',
        textAlign: 'center',
        color: '#FFF',
      },
      '& li':{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '7px',
        width: '85px'
      },
      '@media (min-width: 1000px)': {
        gap: '100px',
        '&.customerFormText':{
          gap: '40px',
          marginRight: '30px',
        }
      },
      '@media (min-width: 801px) and (max-width: 999px)': {
        gap: '50px'
      },
      '@media (max-width: 800px)': {
        gap: '35px'
      },
      '@media (max-width: 700px)': {
        gap: '10px'
      },
      '@media (max-width: 600px)': {
        gap: '50px'
      }
    },
    "& $flex ": {
      gap: '10px',
      "& > button": {
        width: '145px',
        height: 'auto',
        padding: '5px 0',
        gap: '10px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
    },
    '@media (min-width: 601px)': {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  },
  modal: {},
  loyaltySubscribe: {},
  loyaltyConditions: {},
  login: {
    "& form": {
      paddingBottom: '15px',
      width: '295px',
      '& $boxText':{
        margin: '12px auto',
        maxWidth: '270px',
        '@media (min-width: 901px)': {
          width: '350px',
        }
      },
      '& button':{
        fontStyle: 'normal',
        maxWidth: '180px',
        background: '#eaf6ff',
        borderColor: '#eaf6ff',
        '& > span':{
          font: '600 16px "Roboto", sans-serif',
          color: '#36404E',
        },
        '&:hover':{
          background: '#b3d4ed',
        },
        '@media (min-width: 901px)': {
          width: '190px',
        }
      },
    },
    "& a": {
      font: data => '500 14px ' + data.fontFamily1,
      color: '#1877f2',
      '&:hover': {
        textDecoration: 'underline',
        cursor: 'pointer'
      }
    },
    '& + div':{
      padding: '0',
      '& > button':{
        fontStyle: 'normal',
        '& > span':{
          fontSize: '15px',
        }
      }
    }
  },
  accountLogin:{
    display: 'block',
    marginTop: '18px'
  },
  modalContainer:{
    '&.login':{
      padding: '25px',
      '& > div':{
        maxWidth: 'fit-content'
      }
    },
    '&.register':{
      padding: '35px',
      '& > div':{
        maxWidth: 'fit-content'
      }
    },
    '& > div':{
      maxWidth: '980px',
      margin: '0 auto',
      '& > div':{
        '& > div':{
          '& > button':{
            top: '8px',
            right: '8px',
            width: 'auto',
            color: '#86909D',
          },
          '& $header':{
            padding: '20px 20px 14px 20px',
            borderBottom: 'none',
            textAlign: 'center',
            '& > span':{
              fontSize: '19px',
            },
            fontSize: '19px',
          },
          '& $register':{
            maxWidth: '900px',
            margin: '0 auto',
            padding: '15px 0px',
            '@media (min-width: 601px)': {
              padding: '15px 70px',
            },
            '& $fullWidth':{
              width: '140px',
              background: '#eaf6ff',
              borderColor: '#eaf6ff',
              font: '600 16px "Roboto", sans-serif',
              '@media (min-width: 901px)': {
                width: '260px',
              },
              '& > span':{
                color: '#36404E',
              },
              '&:hover':{
                background: '#b3d4ed',
              },
            },
            '& $loyaltySubscribe':{
              padding: '7px 0 25px',
              '@media (min-width: 901px)': {
                padding: '10px 0 25px',
              },
              '& > label':{
                '& > span':{
                  fontSize: '11px'
                },
                '& > div':{
                  '&:after':{
                    width: '14px',
                    height: '14px',
                  }
                }
              }
            },
            '& $loyaltyConditions':{
              paddingTop: '5px',
              '& > label':{
                fontSize: '11px',
                '& span':{
                  fontSize: '11px',
                },
                '& > div':{
                  '&:after':{
                    width: '14px',
                    height: '14px',
                  }
                }
              }
            },
            '& $textCenter':{
              marginBottom: '5px',
              '& span':{
                paddingRight: '5px',
                fontSize: '11px',
                '@media (min-width: 901px)': {
                  fontSize: '14px',
                  paddingRight: '20px',
                }
              },
              '& a':{
                '& span':{
                  paddingRight: '0',
                  textDecoration: 'underline',
                }
              }
            }
          },
          '& $login':{
            padding: '15px 0',
            '@media (min-width: 601px)': {
              padding: '15px 90px',
            },
          },
        }
      }
    },
    '& $starLogo':{
      paddingTop: '25px',
    },
  },
  boxTextTel:{
    '& label':{
      marginBottom: '0',
    },
    '& > div':{
      boxShadow: '0 0 7px -2px rgba(0, 0, 0, 0.5)',
      border: '1px solid #d8d8d8',
      height: 'auto',
    }
  },
  register : {
    padding: '35px',
    "& form " :{
      padding: '10px 0',
      "& > div": {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '0 2%',
        flexDirection: 'column',
        '@media (min-width: 901px)': {
          flexDirection: 'row',
        },
        "&.text": {
          padding: '10px 0'
        },
        "& > label": {
          flex: 'calc(50% - 1%)'
        },
        "& > div": {
          flex: 'calc(50% - 1%)',
          display: 'flex',
          "& > label": {
            flex: "auto"
          }
        }
      },
      '& $checkBox': {
        paddingLeft: '29px', 
        display: 'block',
        position: 'relative',
        '& $inputCheck': {
          position: 'absolute',
          top: '0',
          left: '0',
          outline: 'none',
          '&:lang(ar)': {
            left: 'auto',
            right: 0
          },
        },
      }
    },
    "& a": {
      font: data => '500 14px ' + data.fontFamily1,
      color: '#1877f2',
      '&:hover': {
        textDecoration: 'underline',
        cursor: 'pointer'
      }
    }
  },
  loginado:{    
    '& $section':{
      gap: '5px',
      display: 'flex',
      flexDirection: 'column',
      border: 'none',
      '@media (min-width: 601px)': {
        flexDirection: 'row',
        '& > div':{
          gap: '0',
          flex: 'auto!important',
          alignItems: 'flex-start!important',
        }
      }
    },
    '& $buttonLogin':{
      background: '#F7F7F7',
      width: '129px',
      border: 'none',
      outline: 'none',
      '& span':{
        color: '#747F8D'
      },
      '&:focus':{
        border: 'none',
        outline: 'none',
      }
    } 
  },
  info: {
    display:  'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    font: data => '12px ' + data.fontFamily1,
    color: '#4F5D70',
    "& $textInfo": {
      marginLeft: '15px',
    },
    "& $section" : {      
      color: '#4F5D70 !important',
    },
    "& $withBorder": {
      padding: '0 10px',
      borderLeft: '1px solid #4F5D70',
      borderRight: '1px solid #4F5D70',
    },
    "& $flex > div" : {
      flex : '50%',
      width: '50px',
    },
    "& $flex:first-child > div" : {
      width: '100px'
    },
    "& $flex:last-child > div" : {
      width: '70px'
    },
    "&$column": {
      marginTop: '10px',
      "& $textInfo": {
        width: '100%',
        textAlign: 'center',
        marginTop: '20px'
      },
      "& $textCenter": {
        marginTop: '20px'
      },
      "& $section" : {      
        flexDirection: 'row',
        "& > div" : {      
          flexDirection: 'column'
        }
      }
    }
  },
  withBorder: {},
  textInfo: {},
  header: {
    position: 'relative',
    display: 'block',
    padding: '11px 20px 14px 20px',
    borderBottom: '1px solid #d8d8d8',
    textAlign: 'left',
    '& $title': {
      font: "18px 'Droid Serif'",
      '@media (min-width: 901px)': {
        fontSize: '24px'
      }
    },
  },
  starLogo:{
    maxWidth: '130px',
    width: '100%',
    fill: '#4F5D70 !important',
    '& > svg':{
      '@media (min-width: 601px)': {
        marginBottom: '15px',
      }
    },
    '&$customerFormLogo':{
      maxWidth: '160px',
    },
    '&:not($customerFormLogo)':{
      '@media (min-width: 601px)': {      
        margin: '0 40px 0 15px',
      },
      '@media (min-width: 801px)': {      
        /* margin: '0 60px 0 0', */
        margin: '0'        
      },
    },
  },
  ftLogoModal:{    
    width: '100%',
    margin: '0 auto',
    fill: '#4F5D70',
    paddingTop: '25px',
    maxWidth: '130px',
    '@media (min-width: 901px)': {
      maxWidth: '280px',
    },
  },
  contentCustomerForm:{},
  content: {
    padding: '15px',
    position: 'relative',
    '&$contentCustomerForm':{
      background: 'transparent linear-gradient(180deg, #909AAA 0%, #4E5C6F 100%) 0% 0% no-repeat padding-box',
      marginBottom: '20px',
    }    
  },
  boxText: {
    position: 'relative',
    display: 'block',
    textAlign: 'left',
    marginBottom: '15px',
    paddingLeft: '0',
    '& $labelText': {
      position: 'absolute',
      top: '14px',
      left: '15px',
      zIndex: '0',
      color: '#36404E',
      right: '10px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      font: data => '300 11px ' + data.fontFamily1,
      ...mixins.transition('top 0.3s'),
      '@media (min-width: 901px)': {
        top: '18px',
        fontSize: '13px'
      },
      '&:lang(ar)': {
        left: 'auto',
        right: '15px',
        '@media (min-width: 901px), print': {
          float: 'right'
        }
      },
    },
    '& $inputText': {
      font: data => '300 13px ' + data.fontFamily1,
      '&:focus ~ $labelText, &:not([value=""]) ~ $labelText': {
        top: '6px'
      },
      '@media (min-width: 901px)': {
        height: '52px',
        fontSize: '16px'
      }
    }
  },
  buttonRegister: {
    font: '600 12px "Roboto", sans-serif',
    background: '#addbff',
    border: '1px solid #addbff',
    minHeight: '30px',
    '&:hover': {
      background: '#88b5d9',
      color: '#addbff'
    },
    '& span':{
      color: '#36404E',
    }
  },
  buttonLogin: {
    background: '#e9f5fe',
    font: '600 12px "Roboto", sans-serif',
    border: '0px solid #addbff',
    minHeight: '30px',
    '&:hover': {
      background: '#c5d6e3',
      color: '#addbff'
    },
    '& span':{
      color: '#36404E',
    }
  },
  flex: {
    display: 'flex',
    gap: '2px',
    '@media (max-width: 600px)': {
      marginTop: '20px',
    },
    '@media (min-width: 601px)': {
      flexDirection: 'column',
    },
    '@media (min-width: 801px)': {
      flexDirection: 'column',
    }
  },
  fullWidth: {
    width: '100%'
  },
  textLeft: {
    textAlign: 'left'
  },
  textCenter: {
    textAlign: 'center'
  },
  title: {}, 
  labelText: {},
  inputText: {},
  errorText: {
    color: '#d0021b',
    display: 'block',
    fontSize: '12px',
    textAlign: 'left',
    marginTop: '10px'
  },
  horizontal : {
    background: 'transparent',
    margin: '0 auto',
    "& $info ": {
      "& $section ": {
        display: 'flex',
        gap: '20px',
        "& $flex": {flex : '33%'}
      }
    },
    '& $header':{
      textAlign: 'center',
      paddingTop: '14px',
      paddingBottom: '11px',
    },
    '& $content':{
      'padding': '0',
      '& .text':{
        '& span':{
          fontSize: '12px',
          color: '#fff',
          '@media (min-width: 901px)': {
            fontSize: '15px',
          }
        },
        '& svg': {
          width: '22px',
          height: '21px',
          '@media (min-width: 601px)': {
            width: '30px',
            height: '29px',
          }
        }
      },
      '& $flex':{
        '& button':{
          '& span':{
            fontStyle: 'normal',
            font: '600 12px "Roboto", sans-serif'
          },
          '&:not(:first-of-type)':{
            borderColor: '#e9f5fe',
            height: '30px',
            lineHeight: '15px',
            '& span':{
              color: '#36404E',
            }
          },
        },
        '@media (min-width: 901px)': {
          flex: 'initial',
          justifyContent: 'space-evenly',
          alignItems: 'center',
          '& button':{
            width: '144px',
          }
        }
      },
      '& $starLogo': {
        width: '100%',
        maxWidth: '114px',
        margin: '0 auto',
        fill: data => data.mainColor,
        '@media (min-width: 601px)': {
          margin: '0 40px 0 15px',
          maxWidth: '160px',
        },
        '@media (min-width: 801px)': {
          margin: '0 60px 0 15px'
        }
      },
      '@media (min-width: 601px)': {
        'paddingRight': '30px!important',
      }
    },
  },
  vertical : {},
  section : {},
  starTabTitle:{
    display:'block',
    font: '12px "Roboto", sans-serif',
    '@media(min-width:601px)':{
      fontSize: '14px',
    }
  },
  starTabSubTitle:{
    font: '14px "Roboto", sans-serif',
  },
  starOfferContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#fff',
    '& div': {
      textAlign: 'left',
      marginLeft: '15px',
      font: '14px "Roboto", sans-serif',
      color: '#c94',
      '@media(max-width:601px)':{
        fontSize: '12px',
      },
    },
  },
  starOfferDiscount: {  
    paddingRight: '10px',
    font: '30px "Roboto", sans-serif',
    color: '#ada7a7',
    borderRight: '1px solid #847648',
  },
  starOfferTitle: {
    fontWeight: '600',
  },
  politicsText: {
    color: '#36404E',
    fontWeight: 'bold',
  },
  column: {
    flexDirection: 'column',
  },
  uppercase: {
    textTransform: 'uppercase'
  },
  loyaltyIcon:{
    marginRight: '5px'
  },
  titleInfo:{
    display: 'block',
    paddingBottom: '8px',
    '@media (min-width: 601px)': {
      paddingBottom: '2px',
    }
  },
  checkBox: {},
  inputCheck: {},
  starTravLogInLogo: {},
  starTravLogInTxt: {},
  starTravLogBtn: {},
  starTravLogInSection:{
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    marginBottom: '10px',
    padding: '10px',
    '@media (min-width: 801px)': {
      justifyContent: 'flex-start',
      flexWrap: 'nowrap',
      padding: '10px',
      marginBottom: '15px',
    },
    '& $starTravLogInLogo':{
      width: '40%',
      maxWidth: '100px',
      '@media (min-width: 801px)': {
        margin: '0 30px',
        maxWidth: 'unset',
      },
    },
    '& $starTravLogInTxt':{
      font: '14px "Roboto", sans-serif',
      width: '60%',
      '@media (min-width: 801px)': {
        width: '50%',
      },
    },
    '& button':{
      font: '14px "Roboto", sans-serif',
      margin: '10px 0',
      background: data => data.STdefaultTier,
      border: '1px solid',
      borederColor: data => data.STdefaultTier,
      '&:hover':{
        color: data => data.STdefaultTier,
      },
      '@media (min-width: 801px)': {
        marginLeft: '30px',
        maxWidth: '180px',
      },
    }
  }
};
